<template>
	<div class="system">
		<layout width="200px">
			<template v-slot:left>
				<publicMenu :list="list" iconUrl="list"></publicMenu>
			</template>
			<template v-slot:right>
				<router-view></router-view>
			</template>
		</layout>
	</div>
</template>

<script>
	import layout from '../../components/layout.vue'
	import publicMenu from '../../components/publicMenu.vue'

	export default {
		watch:{
			"$route"(val){
				console.log(888888888888888);
				console.log(val);
				// this.getPath()
			}
		},
		data() {
			return {
				list: [],
				name:"",
			}
		},
		components: {
			layout,
			publicMenu,
		},
		methods: {
			getPath(){
				let path = this.$route.path
				if(path=="/index/apartment/applyCheckIn"){
					this.name="人才信息"
				}
			},
			getAll() {
				var a = JSON.parse(localStorage.getItem("cd"))
				console.log(a)
				a.forEach(val => {
					if (val.meta.title == '访客') {
						var b = val.children
						console.log(b)
						this.list = b
						console.log(this.list)
					}
				
				})
				return
				this.$http.get(
					`/api/api/findMenusByRoleIdAndPath?path=${this.$route.matched[1].path}&roleId=${sessionStorage.roleId}`).then(res => {
					this.list = res.data.data;
					// if(location.href.indexOf())
					// this.$router.push(this.list[0].bdMenus[0].path);
				
				})
			}
		},
		mounted() {
			this.getPath()
			this.getAll()
		}
	}
</script>

<style scoped="scoped">

</style>
